import React from "react";
import "./Intro.css"

export default function Intro(){
    return (
        <div className="Intro text-center">
            <h1>DRAGON</h1>
            <p>SENDING HUMANS AND CARGO INTO SPACE</p>
        </div>
    )
}